import { useEffect, useState } from "react";
import { getCompletedSections, getCurrentSection } from "../utils/trainingStorage";

export const useSectionCompletion = (selectedProduct: string) => {
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    const completedSections = getCompletedSections(selectedProduct);
    const currentSectionIndex = getCurrentSection(selectedProduct);
    setIsCompleted(currentSectionIndex <= completedSections);
  }, [selectedProduct]);

  return isCompleted;
};
